import { format } from 'date-fns';

export const TOOLTIP_OFFSET_Y = -45;

export const formatDate = (date: Date, locale: string) => {
  const dateStr = new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
  }).format(date);
  const time = format(date, 'h:mm a');
  const tz =
    new Intl.DateTimeFormat(locale, { timeZoneName: 'short' })
      .formatToParts(date)
      .find(p => p.type === 'timeZoneName')?.value ?? '';

  return `${dateStr}, ${time} ${tz}`;
};

export const formatPercentChange = (value: number) => {
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}%`;
};
